var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSbfLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "433.68515pt",
    height: "115.30638pt",
    viewBox: "0 0 434.68513 116.30638",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-67.000024,-146.75)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#58585b",
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7.086,37.5567 3.148,0 c 3.998,0 5.452,-2.3038 5.452,-6.7247 0,-4.4824 -1.696,-6.7236 -6.178,-6.7236 l -2.422,0 0,13.4483 z m 0.424,-19.627 2.726,0 c 2.844,0 5.028,-1.9385 5.028,-5.5723 0,-4.0586 -1.575,-6.1787 -4.907,-6.1787 l -2.847,0 0,11.751 z M 0,0 11.145,0 c 8.054,0 11.628,4.1201 11.628,11.5694 0,3.7568 -1.574,7.6923 -5.209,9.1474 3.817,1.6963 6.059,4.7236 6.059,10.3574 0,7.208 -3.211,12.6602 -11.754,12.6602 L 0,43.7344 0,0 Z",
    transform: "translate(204.875,156.535)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#58585b",
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7.51,33.5576 c 0,3.2715 0.97,4.8467 4,4.8467 3.027,0 3.996,-1.5752 3.996,-4.8467 l 0,-22.167 c 0,-3.27047 -0.969,-4.84667 -3.996,-4.84667 -3.03,0 -4,1.5762 -4,4.84667 l 0,22.167 z M 0,11.207 C 0,5.02833 3.633,0 11.51,0 19.385,0 23.017,5.02833 23.017,11.207 l 0,22.5322 c 0,6.1797 -3.632,11.2071 -11.507,11.2071 C 3.633,44.9463 0,39.9189 0,33.7392 L 0,11.207 Z",
    transform: "translate(233.506,155.929)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#58585b",
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 15.627,11.3886 C 15.324,7.63283 13.324,6.54393 11.629,6.54393 c -2.424,0 -3.756,1.5762 -3.756,4.29977 0,7.4512 15.265,11.0244 15.265,22.8955 0,7.21 -4.845,11.2071 -11.873,11.2071 C 4.299,44.9463 0.301,39.374 0,32.832 l 7.146,-1.0293 c 0.303,4.4209 2.059,6.6016 4.483,6.6016 2.605,0 4.359,-1.3936 4.359,-3.9981 C 15.988,25.7441 0.726,23.4424 0.726,10.9043 0.726,3.93753 4.965,0 12.355,0 c 6.117,0 9.754,4.42383 10.42,10.6015 l -7.148,0.7871 z",
    transform: "translate(260.383,155.929)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#58585b",
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 7.266,6.543 0,6.543 0,0 l 22.047,0 0,6.543 -7.269,0 0,37.1914 -7.512,0 0,-37.1914 z",
    transform: "translate(284.863,156.535)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#58585b",
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9.689,27.501 6.059,0 -2.969,-18.7774 -0.121,0 L 9.689,27.501 Z M 7.269,43.7344 0,43.7344 8.056,0 l 9.328,0 8.055,43.7344 -7.267,0 -1.334,-9.6914 -8.237,0 -1.332,9.6914 z",
    transform: "translate(306.514,156.535)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#58585b",
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7.511,37.5567 2.608,0 c 3.996,0 5.388,-1.5157 5.388,-6.1202 l 0,-19.1396 c 0,-4.6035 -1.392,-6.1182 -5.388,-6.1182 l -2.608,0 0,31.378 z M 0,0 11.148,0 C 18.9,0 23.019,4.2403 23.019,13.2041 l 0,17.3242 c 0,8.9649 -4.119,13.2061 -11.871,13.2061 L 0,43.7344 0,0 Z",
    transform: "translate(336.307,156.535)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#58585b",
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 15.627,11.3886 C 15.322,7.63283 13.324,6.54393 11.629,6.54393 c -2.422,0 -3.754,1.5762 -3.754,4.29977 0,7.4512 15.264,11.0244 15.264,22.8955 0,7.21 -4.848,11.2071 -11.874,11.2071 C 4.299,44.9463 0.303,39.374 0,32.832 l 7.146,-1.0293 c 0.303,4.4209 2.061,6.6016 4.483,6.6016 2.605,0 4.361,-1.3936 4.361,-3.9981 C 15.99,25.7441 0.724,23.4424 0.724,10.9043 0.724,3.93753 4.965,0 12.355,0 c 6.119,0 9.752,4.42383 10.42,10.6015 l -7.148,0.7871 z",
    transform: "translate(362.881,155.929)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#58585b",
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,43.7374 0,0 l 20.959,0 0,6.5411 -13.44728,0 0,11.2666 10.05468,0 0,6.5459 -10.05468,0 0,19.3838 -7.51172,0 z",
    transform: "translate(67,207.613)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#58585b",
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 13.0215,0 6.541,0 0,6.5429 -6.541,0 0,-6.5429 z M 7.5117,42.5263 c 0,3.2706 0.9688,4.8467 3.9961,4.8467 3.0312,0 4,-1.5761 4,-4.8467 l 0,-22.1748 c 0,-3.2685 -0.9688,-4.8437 -4,-4.8437 -3.0273,0 -3.9961,1.5752 -3.9961,4.8437 l 0,22.1748 z m 2.4824,-35.9834 -6.541,0 0,-6.5429 6.541,0 0,6.5429 z M 0,20.1699 C 0,13.9922 3.6347,8.9658 11.5078,8.9658 c 7.875,0 11.5098,5.0264 11.5098,11.2041 l 0,22.5371 c 0,6.1796 -3.6348,11.2076 -11.5098,11.2076 C 3.6347,53.9146 0,48.8866 0,42.707 L 0,20.1699 Z",
    transform: "translate(91.4258,198.041)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#58585b",
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7.6504,19.625 2.666,0 c 4.0567,0 5.5723,-1.5136 5.5723,-6.7236 0,-5.21 -1.5156,-6.7236 -5.5723,-6.7236 l -2.666,0 0,13.4472 z M 7.5098,43.7374 0,43.7374 0,0 10.5371,0 c 8.42,0 12.7207,3.5723 12.7207,12.9014 0,7.0244 -2.7246,9.877 -5.2715,11.0264 l 6.3614,19.8096 -7.6309,0 -5.332,-18.1124 c -0.9668,0.1211 -2.541,0.1817 -3.875,0.1817 l 0,17.9307 z",
    transform: "translate(120.074,207.613)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#58585b",
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 30.5292,0 0,43.7393 -6.543,0 0,-34.167 -0.119,0 -6.7851,34.167 -3.6348,0 -6.7832,-34.167 -0.1231,0 0,34.167 -6.541,0 L 0,0 l 9.875,0 5.3282,25.5683 0.121,0 L 20.6562,0 l 9.873,0 z",
    transform: "translate(149.174,207.611)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#58585b",
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,43.7374 0,0 l 20.11,0 0,6.5411 -12.598,0 0,11.2666 9.692,0 0,6.5459 -9.692,0 0,12.8398 13.445,0 0,6.544 -20.957,0 z",
    transform: "translate(186.482,207.613)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#58585b",
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7.51,37.5605 2.605,0 c 3.996,0 5.391,-1.5156 5.391,-6.1191 l 0,-19.1465 c 0,-4.6025 -1.395,-6.1152 -5.391,-6.1152 l -2.605,0 0,31.3808 z M 0,0 11.144,0 c 7.752,0 11.871,4.2402 11.871,13.2051 l 0,17.3281 c 0,8.9651 -4.119,13.2061 -11.871,13.2061 L 0,43.7393 0,0 Z",
    transform: "translate(211.926,207.611)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#58585b",
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,43.7374 0,0 l 7.512,0 0,37.1934 11.81,0 0,6.544 -19.322,0 z",
    transform: "translate(240.877,207.613)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#58585b",
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 7.511,0 0,43.7393 -7.511,0 L 0,0 Z",
    transform: "translate(263.852,207.611)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#58585b",
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,43.7374 0,0 l 6.967,0 9.144,25.0186 0.123,0 0,-25.0186 6.782,0 0,43.7374 -6.54,0 -9.57,-27.3252 -0.121,0 0,27.3252 -6.785,0 z",
    transform: "translate(278.129,207.613)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#58585b",
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 10.358,22.1689 12.297,0 0,22.1749 -3.635,0 -1.395,-3.273 c -2.24,2.667 -4.056,3.878 -7.57,3.878 C 4.118,44.9488 0,40.7078 0,33.7412 L 0,11.2041 C 0,5.0264 3.635,0 11.024,0 18.534,0 22.29,5.4502 22.29,11.9922 l 0,2.7881 -7.149,0 c 0,-6.543 -1.332,-8.2383 -4.301,-8.2383 -1.816,0 -3.33,1.0898 -3.33,4.7842 l 0,22.4756 c 0,2.789 0.908,4.6054 3.514,4.6054 3.027,0 4.117,-1.6963 4.117,-6.0576 l 0,-4.2412 -4.783,0 0,-5.9395 z",
    transform: "translate(307.521,207.007)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#58585b",
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,43.7374 0,0 l 20.108,0 0,6.5411 -12.598,0 0,11.2666 9.691,0 0,6.5459 -9.691,0 0,12.8398 13.447,0 0,6.544 -20.957,0 z",
    transform: "translate(336.574,207.613)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#58585b",
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,43.7374 0,0 l 6.965,0 9.147,25.0186 0.121,0 0,-25.0186 6.785,0 0,43.7374 -6.545,0 -9.566,-27.3252 -0.123,0 0,27.3252 -6.784,0 z",
    transform: "translate(362.355,207.613)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "symbol",
    style: {
      fill: "#58585b",
      fillRule: "nonzero"
    },
    d: "M 78.563,34.6455 C 55.063,20.7841 32.038,37.7236 28.073,51.8613 33.309,43.4179 40.452,37.622 50.445,37.622 c 14.983,0 28.209,12.3262 28.209,27.3076 0,14.9795 -12.14,27.7295 -27.123,27.7295 -10.121,0 -19.839,-5.6406 -23.905,-15.5839 -2.881,-7.044 -3.219,-12.167 -3.219,-25.0713 l 0,-45.99999 L 16.041,0 0,6.12207 0,63.4951 c 0,29.3965 18.57,52.1299 51.026,51.8079 47.103,-0.466 63.373,-59.5257 27.537,-80.6575",
    transform: "translate(402.666,146.75)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSbfLogo);
export default __webpack_public_path__ + "static/media/sbf_logo.0e7e283ca4748af1c0bfe6e64620f5b6.svg";
export { ForwardRef as ReactComponent };